import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalBody } from 'reactstrap';

function Share(props) {
    const { show, data, type, setShow, remove } = props;

    return (
        <Modal isOpen={show} toggle={() => setShow(false)} backdrop="static" centered className='unlike_modal'>
            <ModalBody>
                <div id="" className={""}>
                    <h3 className="rlr-share__title">Are you sure ?</h3>
                    <div className="share-items">
                        <p>You want to remove this desintaion from favourite?</p>
                        <div className="rlr-copylink">
                           
                            <button className='btn btn-primary' onClick={remove}>
                                Submit
                            </button>
                            <button className='btn btn-danger' onClick={()=>setShow(false)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default Share;